export const getters = {
  getSectors($state) {
    return Object.values($state.records).sort((a, b) => a.id - b.id);
  },
  getSectorById: $state => id => {
    return (
      Object.values($state.records).find(record => record.id === Number(id)) ||
      {}
    );
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getCurrentUserSectorMemberships($state) {
    return $state.currentUserMemberships;
  },
  getAllSectors($state) {
    return $state.allSectors;
  },
};
